export const AUTH = 'AUTH'
export const SIGNOUT = 'SIGNOUT'

export const GENERAL_SETTINGS = 'GENERAL_SETTINGS'

export const STATUS = 'STATUS'
export const UPDATE_CART = 'UPDATE_CART'
export const ORDER_TYPE = 'ORDER_TYPE'
export const DISCOUNT = 'DISCOUNT'

export const LOCATION = 'LOCATION'

export const LOADING_ON = 'LOADING_ON'
export const LOADING_OFF = 'LOADING_OFF'



// WEBPACK FOOTER //
// ./src/store/types.js